import React, { Component } from 'react';
import Inbox from './Inbox.js';

export default class InboxSuratTugas extends Component {
  render() {
    return (
      <Inbox type='TNDE_SURAT_TUGAS'/>
    );
  }
}
